import React from "react";
import "../../Main.css";
import classes from "./portfolio.module.css";

import Html5Icon from "../../img/html-5.svg";
import Css3Icon from "../../img/css-3.svg";
import JsIcon from "../../img/js.svg";
import AngularIcon from "../../img/angular.svg";
import IonicIcon from "../../img/ionic.png";
import ReactIcon from "../../img/react.svg";
import GitIcon from "../../img/git.svg";
import FirebaseIcon from "../../img/firebase.png";

import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const Portfolio = () => {
  return (
    <div className={[classes.PortfolioPage, "flex-content", "Page"].join(" ")}>
      <h1 datatype="My recent work">My recent work</h1>

      <div className={classes.Content}>
        <div className={[classes.Item, classes.Amazon].join(" ")}>
          <h2>Amazon Clone</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://react-amzn.web.app/"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={JsIcon} alt="Js icon" />
              <img src={ReactIcon} alt="React icon" />
              <img src={FirebaseIcon} alt="Firebase icon" />
            </p>
          </div>
        </div>
        <div className={[classes.Item, classes.Covid19].join(" ")}>
          <h2>COVID 19 Tracker</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://covid-tracker-1e566.web.app/"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={JsIcon} alt="Js icon" />
              <img src={ReactIcon} alt="React icon" />
              <img src={GitIcon} alt="Git icon" />
            </p>
          </div>
        </div>
        <div className={[classes.Item, classes.InstagramClone].join(" ")}>
          <h2>Instagram Clone</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://instagram-clone-2e5d0.web.app/"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={ReactIcon} alt="React icon" />
              <img src={FirebaseIcon} alt="Firebase icon" />
              <img src={GitIcon} alt="Git icon" />
            </p>
          </div>
        </div>
        <div className={[classes.Item, classes.Spotify].join(" ")}>
          <h2>Spotify Controller</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://spotify-clone-react.web.app/"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={JsIcon} alt="Js icon" />
              <img src={ReactIcon} alt="React icon" />
            </p>
          </div>
        </div>
        <div className={[classes.Item, classes.TinderClone].join(" ")}>
          <h2>Tinder Clone</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://tinder-reactclone.web.app"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={ReactIcon} alt="React icon" />
              <img src={FirebaseIcon} alt="Firebase icon" />
              <img src={GitIcon} alt="Git icon" />
            </p>
          </div>
        </div>
        <div className={[classes.Item, classes.ImageGallery].join(" ")}>
          <h2>Image Gallery</h2>
          <div className={classes.ItemInner}>
            <a
              href="https://image-gallery-react.web.app/"
              className={classes.RedBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Take a look</span> <ArrowForwardIcon />
            </a>
            <p className={classes.Tools}>
              <span>Tools: </span>
              <img src={Html5Icon} alt="Html 5 icon" />
              <img src={Css3Icon} alt="Css 3 icon" />
              <img src={ReactIcon} alt="React icon" />
              <img src={FirebaseIcon} alt="Firebase icon" />
              <img src={GitIcon} alt="Git icon" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
